import { withStyles } from '@material-ui/core/styles';

const styled = withStyles(theme => {
  return {
    root: {},
    header: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'center',
      alignItems: 'center',
      padding: 20,
      margin: '0px auto'
    },
    profileItem: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center'
    },
    timeAgo: {
      whiteSpace: 'nowrap',
      margin: '0px 20px'
    },
    timeAgoMsg: {
      whiteSpace: 'nowrap'
    },

    tableWrapper: {
      backgroundColor: '#fff',
      overflow: 'auto',
      margin: '30px auto',
      maxWidth: 700
    },

    messagesContainer: {
      // width: '100vw',
      maxWidth: 600,
      display: 'flex',
      flexDirection: 'column',
      margin: '0px auto',
      padding: 10
    },

    message: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'flex-start',
      '&.right': {
        alignSelf: 'flex-end',
        flexDirection: 'row-reverse'
      },
      '&.left': {},
      marginBottom: 10,
      '&:last-child': {
        marginBottom: 0
      }
    },

    messageAvatar: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      '&.right': {
        marginLeft: 10
      },
      '&.left': {
        marginRight: 10
      }
    },

    messageText: {
      backgroundColor: '#eee',
      borderRadius: 5,
      padding: '5px 10px'
    },

    messagePhoto: {
      width: 200,
      borderRadius: 10,
    },

    messageCol: {
      width: '100%'
    }
  };
});

export default styled;
